import React from 'react'

function ArrowIcon(props) {
  const { color } = props;
  return (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M15.8337 10H4.16699" stroke={color || "#E81255"} strokeWidth="1.67" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M10.0003 15.8332L4.16699 9.99984L10.0003 4.1665" stroke={color || "#E81255"} strokeWidth="1.67" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  )
}

export default ArrowIcon